exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".file-preview[data-v-570869db]{width:100%;height:100%;overflow:hidden;text-align:center}.file-preview.transparent[data-v-570869db]{background-color:transparent}.filename-area[data-v-570869db]{padding:20px;position:absolute;left:30px;top:80px;color:#fff;background-color:rgba(0,0,0,.5);border-radius:10px;max-width:calc(100% - 60px)}", ""]);

